"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TOGGLE_TYPE_SECONDARY = exports.TOGGLE_TYPE_PRIMARY = exports.TOGGLE_SIZE_SMALL = exports.TOGGLE_SIZE_MEDIUM = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));
var _react = _interopRequireDefault(require("react"));
var T = _interopRequireWildcard(require("prop-types"));
var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntl = require("react-intl");
var _constants = require("../../constants");
var _AutoIntl = _interopRequireDefault(require("./AutoIntl"));
var _AuAnalytics = _interopRequireDefault(require("../../utils/AuAnalytics"));
var _context2;
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "container": "au_toggle-module__container___kduO_",
  "switch": "au_toggle-module__switch___d_gnG",
  "disabled": "au_toggle-module__disabled___ZjShH",
  "label": "au_toggle-module__label___UNkQ8",
  "handle": "au_toggle-module__handle___xySe4",
  "caption": "au_toggle-module__caption___s15gB",
  "left": "au_toggle-module__left___YrOZ7 au_toggle-module__caption___s15gB",
  "right": "au_toggle-module__right___cWowu au_toggle-module__caption___s15gB",
  "small": "au_toggle-module__small___id50s",
  "content": "au_toggle-module__content___Rh0lZ",
  "minimalistic": "au_toggle-module__minimalistic___rB5kO",
  "medium": "au_toggle-module__medium___Bg6mg",
  "primary": "au_toggle-module__primary___rm5kO",
  "secondary": "au_toggle-module__secondary___ZAG3K"
};
const TOGGLE_SIZE_SMALL = exports.TOGGLE_SIZE_SMALL = 'small';
const TOGGLE_SIZE_MEDIUM = exports.TOGGLE_SIZE_MEDIUM = 'medium';
const TOGGLE_TYPE_PRIMARY = exports.TOGGLE_TYPE_PRIMARY = 'primary';
const TOGGLE_TYPE_SECONDARY = exports.TOGGLE_TYPE_SECONDARY = 'secondary';

/**
 * Creates HTML toggle element
 * @param {string}   name                   HTML elemet name to be used for unique id assignment.
 * @param {string}   type                   Toggle type passed along as a class modifier. One of:
 *                                            - primary
 *                                            - secondary
 * @param {string}   size                   Toggle size passed along as a class modifier. One of:
 *                                            - small
 *                                            - medium
 * @param {any}      value                  Toggle value (can be tracked throught the event handler).
 * @param {boolean}  checked                When `True` is pased - renders component in `On` state,
 *                                          otherwise - in `Off` state.
 * @param {boolean}  disabled               Enables or disables toggle interactions.
 * @param {boolean}  minimalistic           When `True` is passed - renders labels inside the toggle elemenet,
 *                                          otherwise - outside.
 * @param {string}   showLabels             Shows or hides toggle labels.
 * @param {string}   className              Component container class name.
 * @param {string}   switchClassName        Switch element class name.
 * @param {string}   handleClassName        Handle element class name.
 * @param {string}   labelClassName         Label element class name.
 * @param {string}   captionClassName       Captions element class name.
 * @param {string}   onDisplayId            Localization id to be used as a label for `On` state.
 * @param {string}   onDisplayString        Text caption to be rendered as a label for `On` state.
 * @param {string}   offDisplayId           Localization id to be used as a label for `Off` state.
 * @param {string}   offDisplayString       Text caption to be rendered as a label for `Off` state.
 * @param {function} onChange               Toggle onClick handler.
 * @param {object}   intl                   Instance of react-intl.
 */
class AuToggle extends _react.default.PureComponent {
  static sizes = [TOGGLE_SIZE_SMALL, TOGGLE_SIZE_MEDIUM];
  static types = [TOGGLE_TYPE_PRIMARY, TOGGLE_TYPE_SECONDARY];
  static propTypes = {
    name: T.string.isRequired,
    type: T.oneOf(AuToggle.types),
    size: T.oneOf(AuToggle.sizes),
    value: T.any,
    checked: T.bool,
    disabled: T.bool,
    showLabels: T.bool,
    minimalistic: T.bool,
    className: T.string,
    switchClassName: T.string,
    handleClassName: T.string,
    labelClassName: T.string,
    captionClassName: T.string,
    onDisplayId: T.string,
    onDisplayString: T.string,
    offDisplayString: T.string,
    offDisplayId: T.string,
    onChange: T.func
  };
  static defaultProps = {
    type: TOGGLE_TYPE_PRIMARY,
    size: TOGGLE_SIZE_MEDIUM,
    checked: false,
    showLabels: false,
    minimalistic: false,
    onDisplayString: '',
    offDisplayString: '',
    onChange: _constants.NOOP
  };
  id = (0, _uniqueId.default)(this.props.name);
  formatDisplayString(displayStr) {
    var _context;
    return (0, _map.default)(_context = displayStr.split(' ')).call(_context, _AuAnalytics.default.formatTrackingText).join('');
  }
  getDisplayAction() {
    const {
      checked,
      intl
    } = this.props;
    if (checked) {
      const {
        onDisplayId,
        onDisplayString
      } = this.props;
      if (onDisplayId) {
        return this.formatDisplayString(intl.formatMessage({
          id: onDisplayId
        }));
      }
      if (onDisplayString) {
        return this.formatDisplayString(onDisplayString);
      }
    } else {
      const {
        offDisplayId,
        offDisplayString
      } = this.props;
      if (offDisplayId) {
        return this.formatDisplayString(intl.formatMessage({
          id: offDisplayId
        }));
      }
      if (offDisplayString) {
        return this.formatDisplayString(offDisplayString);
      }
    }
  }
  handleOnChange = (0, _bind.default)(_context2 = this.handleOnChange).call(_context2, this);
  handleOnChange(event) {
    const {
      tracking,
      onChange
    } = this.props;
    if (tracking) {
      _AuAnalytics.default.trackEvent({
        category: tracking.element || 'Toggle',
        action: tracking.action || this.getDisplayAction(),
        label: tracking.page
      });
    }

    // Call actual onChange
    onChange && onChange(event);
  }
  render() {
    const {
      name,
      type,
      size,
      value,
      checked,
      disabled,
      showLabels,
      minimalistic,
      className,
      switchClassName,
      handleClassName,
      labelClassName,
      captionClassName,
      onDisplayId,
      onDisplayString,
      offDisplayId,
      offDisplayString,
      intl
    } = this.props;
    const onText = onDisplayId ? intl.formatMessage({
      id: onDisplayId
    }) : onDisplayString;
    const offText = offDisplayId ? intl.formatMessage({
      id: offDisplayId
    }) : offDisplayString;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.container, styles[type], styles[size], {
        [styles.minimalistic]: minimalistic
      }, className)
    }, showLabels && !minimalistic && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: (0, _classnames.default)(styles.left, captionClassName),
      htmlFor: this.id,
      displayId: offDisplayId,
      displayString: offDisplayString
    }), /*#__PURE__*/_react.default.createElement("label", {
      className: (0, _classnames.default)(styles.switch, {
        [styles.disabled]: disabled
      }, switchClassName)
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      id: this.id,
      name: name,
      value: value,
      disabled: disabled,
      defaultChecked: checked,
      onChange: this.handleOnChange
    }), minimalistic && /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(styles.label, labelClassName),
      "data-tg-on": onText,
      "data-tg-off": offText
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: styles.content
    }, /*#__PURE__*/_react.default.createElement("div", null, onText), /*#__PURE__*/_react.default.createElement("div", null, offText))), !minimalistic && /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _classnames.default)(styles.label, labelClassName)
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(styles.handle, handleClassName)
    })), showLabels && !minimalistic && /*#__PURE__*/_react.default.createElement(_AutoIntl.default, {
      className: (0, _classnames.default)(styles.right, captionClassName),
      htmlFor: this.id,
      displayId: onDisplayId,
      displayString: onDisplayString
    }));
  }
}
var _default = exports.default = (0, _reactIntl.injectIntl)(AuToggle);